<template>
  <transition name="el-fade-in-linear">
    <div class="news">
      <div class="main">
        <div class="firstItem1News">
          <img class="firstPic" src="../../static/images/newsPic0.png" />
        </div>
        <div class="firstItemNews">
          <div class="firstTextNews">新闻中心</div>
          <div class="firstText1News">关注新闻动态</div>
          <div class="firstText1News">获取最新资讯</div>
          <div class="lineNews"></div>
          <div class="lineShortNews"></div>
        </div>

        <div class="secondLevelNews secondLevelNewsMargin">
          <div class="secondLevelNewsItem">
            <router-link class="secondItemNews" to="/newsDetail1">
              <img
                class="secondPicNews"
                src="../../static/images/newsPic1.png"
              />
            </router-link>
          </div>
          <div class="secondLevelNewsItem secondLevelNewsItemMargin">
            <router-link class="secondItemNews" to="/newsDetail1">
              <div class="secondTextNews">
                地铁线路拓展至10条 北斗院算法服务升级
              </div>
              <div class="secondTextTimeNews">2020.08.23</div>
              <img
                class="secondTextPicNews"
                src="../../static/images/arrowsRight.png"
              />
            </router-link>
          </div>
          <div class="secondLevelNewsItem">
            <router-link class="secondItemNews" to="/newsDetail">
              <img
                class="secondPicNews"
                src="../../static/images/newsPic2.png"
              />
            </router-link>
          </div>
          <div class="secondLevelNewsItem secondLevelNewsItemMargin">
            <router-link class="secondItemNews" to="/newsDetail">
              <div class="secondTextNews">
                2020爱分析知识图谱厂商报，北斗院榜上有名
              </div>
              <div class="secondTextTimeNews">2020.08.11</div>
              <img
                class="secondTextPicNews"
                src="../../static/images/arrowsRight.png"
              />
            </router-link>
          </div>
        </div>

        <div class="secondLevelNews secondLevelNewsMargin1">
          <div class="secondLevelNewsItem">
            <router-link class="secondItemNews" to="/newsDetail2">
              <img
                class="secondPicNews"
                src="../../static/images/newsPic3.png"
              />
            </router-link>
          </div>
          <div class="secondLevelNewsItem secondLevelNewsItemMargin">
            <router-link class="secondItemNews" to="/newsDetail2">
              <div class="secondTextNews">
                喜报！北斗院荣获智慧交通产业三大奖项
              </div>
              <div class="secondTextTimeNews">2020.07.14</div>
              <img
                class="secondTextPicNews"
                src="../../static/images/arrowsRight.png"
              />
            </router-link>
          </div>
          <div class="secondLevelNewsItem">
            <router-link class="secondItemNews" to="/newsDetail3">
              <img
                class="secondPicNews"
                src="../../static/images/newsPic4.png"
              />
            </router-link>
          </div>
          <div class="secondLevelNewsItem secondLevelNewsItemMargin">
            <router-link class="secondItemNews" to="/newsDetail3">
              <div class="secondTextNews">
                科研硬核 | 城市轨道交通，大客流安全管控如何破题?
              </div>
              <div class="secondTextTimeNews">2020.04.14</div>
              <img
                class="secondTextPicNews"
                src="../../static/images/arrowsRight.png"
              />
            </router-link>
          </div>
        </div>
      </div>
      <div class="newsFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {
    goDetail: function () {
      this.$router.push({
        path: "newsDetail",
      });
    },
  },
};
</script>
<style scoped>
@import "./News.css";
</style>



// WEBPACK FOOTER //
// src/views/News.vue